import * as React from "react";
import styled from "styled-components";

interface ContentSectionProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
}

const ContentSection: React.FC<ContentSectionProps> = ({
  imageSrc,
  imageAlt,
  title,
  description
}) => {
  return (
    <ContentWrapper>
      <StyledImage src={imageSrc} alt={imageAlt} />
      <Title>{title}</Title>
      <Description>{description}</Description>
    </ContentWrapper>
  );
};

const ContentWrapper = styled.div`
  max-width: 460px;

  @media (max-width: 768px) {
    order: 2;
    max-width: 100%;
  }
`;

const StyledImage = styled.img.attrs({
  width: 100,
  height: 100
})`
  width: 100px;
  height: auto;
  object-fit: contain;
  @media (max-width: 768px) {
    display: none;
  }
`;

const Title = styled.h2`
  font-size: 32px;
  margin-bottom: 16px;
  color: #1c1c1f;
  font-weight: 700;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 12px;
  }
`;

const Description = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: #1c1c1f;
  font-weight: 400;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export default ContentSection;
